export const logoExtensions = ['svg', 'png'];
export const logoFileExtensionsForDrop = ['image/svg+xml', 'image/png'];
export const backgroundExtensions = ['png', 'jpeg', 'jpg'];
export const backgroundExtensionsForDrop = [
  'image/png',
  'image/jpeg',
  'image/jpg',
];
export const fileDropText = 'Drag & drop the logo file here, or';
export const maxFileSizeText = 'Max file size 5MB';
